<template>
  <div>
    <v-list-item @click="$emit('click')">
      <v-list-item-avatar>
        <v-icon class="white--text" style="background-color: var(--v-muted-foreground-base);">mdi-folder</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <SubMenu @select="(selection) => $emit(selection, item)" :options="subMenuFolderItems()"/>
      </v-list-item-action>
    </v-list-item>
    <v-divider/>
  </div>
</template>

<script>
import SubMenu from '@/components/sub-menu/index.vue';
import store from '@/common/store';

export default {
  name: 'Folder',
  components: { SubMenu },
  props: {
    item: {
      type: Object,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    subMenuFolderItems() {
      const listActions = [];
      if (this.allowDelete) { listActions.push({ title: 'Excluir', value: 'delete' }); }
      listActions.push({ title: 'Informações', value: 'informations' });
      if (!store.getHasMenu() || store.getHasNotificationConfigAuthority()) {
        listActions.push({ title: 'Emitir Notificação', value: 'manualNotification' });
      }
      return listActions;
    },
  },
};
</script>
